/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import interceptedAxios from '../../../utils/interceptedAxios'
export async function getIntervalReadings (
  assetId: string,
  page: string,
  size: string,
  tenantId: string,
  sortdir: string,
  sortfield: string,
  onSuccess: (intervalReadings: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any

): Promise<void> {
  if (sortfield === 'MEASUREMENT PERIOD') {
    sortfield = 'readingTime'
  } else if (sortfield === 'COLLECTED') {
    sortfield = 'value'
  }
  const url = `/asset-data-service/api/v1/udp/assets/data/register?assetId=${assetId}&tenantId=${tenantId}&page=${page}&size=${size}&sort=${sortfield},${sortdir}`
  interceptedAxios.get(url, { timeout: 15000 })
    .then((response) => {
      if (response.status === 200 && !response.data.error) {
        onSuccess(response.data.data, response.status)
      } else {
        onFailure(response.data.error, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.status)
        } else {
          onFailure(error.message, error.response.status)
        }
      } else {
        onFailure(error.message, error.status)
      }
    })
}
